// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3hcJH","dragIcon":"Choice_dragIcon__Iij6m","left":"Choice_left__1eMJW","input":"Choice_input__1HoUv"};